import { LowerRegions } from '@/modules/configs/region'
import { useDerivativeAccess } from '@/modules/useDerivativesAccess'
import { useSpanishAccess } from '@/modules/useSpanishAccess'

import {
  desktop_au,
  desktop_br,
  desktop_eea,
  desktop_fr,
  desktop_global,
  desktop_sg,
  desktop_tr,
  desktop_uk,
  desktop_us,
  legal_au,
  legal_br,
  legal_eea,
  legal_fr,
  legal_global,
  legal_sg,
  legal_tr,
  legal_us,
  mobile_au,
  mobile_br,
  mobile_eea,
  mobile_fr,
  mobile_global,
  mobile_sg,
  mobile_tr,
  mobile_uk,
  mobile_us,
} from './data'
import {
  auDisclaimers,
  eeaDisclaimers,
  frDisclaimers,
  globalDisclaimers,
  sgDisclaimers,
  spDisclamiers,
  trDisclaimers,
  usDisclaimers,
} from './data/disclaimers'
import type { Legal, NavLinkBlock, NavLinkColumn } from './data/types'

export const getRegionConfig = (
  region: LowerRegions
): {
  desktopMenu: NavLinkColumn[]
  mobileMenu: NavLinkBlock[]
  disclaimers: string[]
  legalLinks: Legal[]
  menuWidth: string
  isShowEALogo: boolean
} => {
  const isEEA = useDerivativeAccess()
  const isSpanish = useSpanishAccess()

  const defaultConfig = {
    desktopMenu: desktop_global,
    mobileMenu: mobile_global,
    disclaimers: globalDisclaimers,
    legalLinks: legal_global,
    menuWidth: '16%',
    isShowEALogo: false,
  }

  if (region === 'us') {
    return {
      ...defaultConfig,
      desktopMenu: desktop_us,
      mobileMenu: mobile_us,
      disclaimers: usDisclaimers,
      legalLinks: legal_us,
      isShowEALogo: true,
    }
  }

  // NOTE GB special case
  if (region === 'eea') {
    if (isSpanish) {
      return {
        ...defaultConfig,
        desktopMenu: desktop_eea,
        mobileMenu: mobile_eea,
        disclaimers: [...globalDisclaimers, ...spDisclamiers],
        legalLinks: legal_eea,
      }
    } else if (isEEA) {
      return {
        ...defaultConfig,
        desktopMenu: desktop_eea,
        mobileMenu: mobile_eea,
        disclaimers: [...globalDisclaimers, ...eeaDisclaimers],
        legalLinks: legal_eea,
      }
    } else {
      return {
        ...defaultConfig,
        desktopMenu: desktop_uk,
        mobileMenu: mobile_uk,
        disclaimers: eeaDisclaimers,
        legalLinks: legal_eea,
      }
    }
  }

  if (region === 'sg') {
    return {
      ...defaultConfig,
      desktopMenu: desktop_sg,
      mobileMenu: mobile_sg,
      disclaimers: sgDisclaimers,
      legalLinks: legal_sg,
      menuWidth: '20%',
    }
  }

  if (region === 'au') {
    return {
      ...defaultConfig,
      desktopMenu: desktop_au,
      mobileMenu: mobile_au,
      disclaimers: auDisclaimers,
      legalLinks: legal_au,
    }
  }

  if (region === 'br') {
    return {
      ...defaultConfig,
      desktopMenu: desktop_br,
      mobileMenu: mobile_br,
      legalLinks: legal_br,
    }
  }

  if (region === 'tr') {
    return {
      ...defaultConfig,
      desktopMenu: desktop_tr,
      mobileMenu: mobile_tr,
      disclaimers: trDisclaimers,
      legalLinks: legal_tr,
      menuWidth: '20%',
    }
  }

  if (region === 'fr') {
    return {
      ...defaultConfig,
      desktopMenu: desktop_fr,
      mobileMenu: mobile_fr,
      disclaimers: frDisclaimers,
      legalLinks: legal_fr,
    }
  }

  return defaultConfig
}
